import { SearchFilterBase } from '../../shared/model/search/searchFilterBase';

export class DocumentoVendaSearchFilter extends SearchFilterBase {
  public dataInicio: Date;
  public dataFim: Date;
  public numDocumento: string;
  public numContrato: string;
  public matricula: string;
  public apenasDocumentosEmAberto: boolean;
}
